import {Controller} from "@hotwired/stimulus"
import sessionStorageKey from "../constants/url_from_outside_tree_key.js";

export default class extends Controller {

  saveRoute(event) {
    event.preventDefault();
    const url = event.currentTarget.getAttribute("href");
    url && sessionStorage.setItem(sessionStorageKey, url);
    window.location.href = url;
  }
}